<template>
  <div>
    <gg-loading v-if="setUp === null" :loading="true" type="card" />
    <!-- Create opens a modal; once the first filter is stored the customer is
         taken to that address's filters (AM-1107). -->
    <feature-setup v-else-if="!setUp" feature="filters" @create="creating = true" />
    <gg-card v-else>
      <gg-card-header>
        <div class="d-flex align-center flex-wrap">
          <span class="mr-auto">Filters by Users</span>
          <gg-btn secondary small class="my-1" @click="creating = true">
            <v-icon left small>mdi-plus</v-icon>Create Filter
          </gg-btn>
        </div>
      </gg-card-header>
      <gg-card-text>
        <filters-table :manage-to="manageTo" />
      </gg-card-text>
    </gg-card>

    <create-filter-modal
      :is-active="creating"
      :service="service"
      :scope-domain="$route.params.maindomain"
      @created="onCreated"
      @close="creating = false"
    />
  </div>
</template>

<script>
import FiltersTable from '@/components/Services/Hosting/Shared/Email/UserFilters/Table'
import FeatureSetup from '@/components/Email/FeatureSetup'
import CreateFilterModal from '@/components/Email/CreateFilterModal'
import emailFeatureSetup from '@/mixins/emailFeatureSetup'
import { accountPath } from '@/consts/email'

// The hosting section's Filters list, shown inside an email account. Manage
// leads to this section's own `filters/:account` rather than the hosting route.
export default {
  name: 'AccountFiltersView',
  components: { FiltersTable, FeatureSetup, CreateFilterModal },
  mixins: [emailFeatureSetup('hasFilters')],
  // Passed down by EmailAccountView, which has already pointed the hosting
  // context at this account's service.
  props: {
    service: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      creating: false,
    }
  },
  methods: {
    manageTo (email) {
      return accountPath(this.$route.params.maindomain, 'filters', email)
    },
    onCreated (account) {
      this.startSetUp()
      if (account) this.$router.push(this.manageTo(account))
    },
  },
}
</script>
